import { nanoid } from 'nanoid';
import { WidgetHelper } from './Widget';
import { WidgetType } from './widgetType';
export const SortationWidgetHelper = {
    create: (data, properties) => WidgetHelper.createNewWidget({
        type: WidgetType.sortation,
        data,
        properties,
    }, true),
    createNewOption: (optionText) => {
        return {
            guid: nanoid(),
            text: optionText,
        };
    },
    isMaxLimitOfOptionReached: (sortationData) => {
        return sortationData.optionsCorrectOrder.length >= 10;
    },
    isMinLimitOfOptionReached: (sortationData) => {
        return sortationData.optionsCorrectOrder.length <= 2;
    },
    isSortationWidget: (widget) => widget.value.type === WidgetType.sortation,
};
